import type { ReactNode } from 'react';

import { Divider, IconButton, Portal, Slide, Typography } from '@mui/material';

import { CloseIcon } from '@shared/ui/icons';

import { SelectionBarContainerStyled } from './selection-bar.styled';

type SelectionBarProps = {
  open: boolean;
  count: number;
  onClear: () => void;
  children: ReactNode;
  countLabel?: (count: number) => string;
};

const defaultCountLabel = (count: number) => `${count} обрано`;

export const SelectionBar = (props: SelectionBarProps) => {
  const { open, count, onClear, children, countLabel = defaultCountLabel } = props;

  return (
    <Portal>
      <Slide in={open} direction="up" mountOnEnter>
        <SelectionBarContainerStyled role="toolbar">
          <Typography variant="body2" fontWeight={500} px={1}>
            {countLabel(count)}
          </Typography>
          <IconButton size="small" onClick={onClear} sx={{ color: 'inherit' }}>
            <CloseIcon fontSize="small" />
          </IconButton>
          <Divider
            orientation="vertical"
            flexItem
            sx={{ borderColor: 'currentColor', opacity: 0.24, my: 0.5 }}
          />
          {children}
        </SelectionBarContainerStyled>
      </Slide>
    </Portal>
  );
};
